export default __webpack_public_path__ + "static/media/config.d9059128.svg";